import "./ontologies/qads";

//SHAPES FIRST
import "./shapes/QuoraAPI";

//THEN COMPONENTS
import "./components/ExampleComponent";
